import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "not-uploaded--sprite",
  "use": "not-uploaded--sprite-usage",
  "viewBox": "0 0 7 2",
  "content": "<symbol viewBox=\"0 0 7 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"not-uploaded--sprite\">\n<path d=\"M0.5015 1.62V0.564H6.5015V1.62H0.5015Z\" fill=\"#717188\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol